/* Vitasonic Labs — NMN Landing interactions.
   No dependencies. IntersectionObserver-driven, reduced-motion aware. */
(function () {
  'use strict';

  if (window.__vsnlInit) return;
  window.__vsnlInit = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Analytics helper (custom events; pixels handle commerce) ---------- */
  function track(eventName, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(eventName, detail || {});
      }
    } catch (e) { /* no-op */ }
  }
  window.vsnlTrack = track;

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.vsnl-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          ro.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Scroll depth ---------- */
  var depths = [25, 50, 75, 100];
  var fired = {};
  function onScrollDepth() {
    var d = document.documentElement;
    var pct = Math.round(((window.scrollY + window.innerHeight) / d.scrollHeight) * 100);
    depths.forEach(function (m) {
      if (pct >= m && !fired[m]) {
        fired[m] = true;
        track('vsnl_scroll_depth', { depth: m });
      }
    });
    if (fired[100]) window.removeEventListener('scroll', onScrollDepthThrottled);
  }
  var depthTick = false;
  function onScrollDepthThrottled() {
    if (depthTick) return;
    depthTick = true;
    setTimeout(function () { onScrollDepth(); depthTick = false; }, 400);
  }
  window.addEventListener('scroll', onScrollDepthThrottled, { passive: true });

  /* ---------- Hero 3D card (pointer parallax / drag tilt) ---------- */
  document.querySelectorAll('[data-vsnl-hero3d]').forEach(function (stage) {
    var card = stage.querySelector('.vsnl-hero3d__card');
    if (!card || reducedMotion) return;
    var raf = null;
    var active = false;

    function setTilt(rx, ry) {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
      });
    }
    function onMove(e) {
      if (!active) return;
      var r = card.getBoundingClientRect();
      var cx = e.clientX - r.left, cy = e.clientY - r.top;
      var ry = ((cx / r.width) - 0.5) * 14;
      var rx = (0.5 - (cy / r.height)) * 10;
      setTilt(rx, ry);
    }
    function reset() {
      active = false;
      if (raf) cancelAnimationFrame(raf);
      card.style.transition = 'transform 0.6s ease';
      card.style.transform = 'rotateX(0deg) rotateY(0deg)';
      setTimeout(function () { card.style.transition = 'transform 0.25s ease-out'; }, 600);
    }
    // Pointer hover on desktop only; touch scroll must stay free.
    stage.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') active = true;
    });
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerleave', reset);

    // Pause when offscreen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (!en.isIntersecting) reset(); });
      }, { threshold: 0 }).observe(stage);
    }
  });

  /* ---------- Science steps: activate on scroll ---------- */
  var steps = document.querySelectorAll('.vsnl-step');
  if (steps.length && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) en.target.classList.add('is-active');
      });
    }, { threshold: 0.5 });
    steps.forEach(function (s) { so.observe(s); });
  }

  /* ---------- Capsule exploration ---------- */
  document.querySelectorAll('[data-vsnl-capsule]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) track('vsnl_capsule_open', {});
    });
  });

  /* ---------- COA scan (activate in viewport) + COA click ---------- */
  document.querySelectorAll('[data-vsnl-scan]').forEach(function (wrap) {
    if ('IntersectionObserver' in window && !reducedMotion) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          wrap.classList.toggle('is-scanning', en.isIntersecting);
        });
      }, { threshold: 0.35 }).observe(wrap);
    }
  });
  document.querySelectorAll('[data-vsnl-coa-link]').forEach(function (a) {
    a.addEventListener('click', function () { track('vsnl_coa_click', { href: a.href }); });
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.vsnl-faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var expanded = q.getAttribute('aria-expanded') === 'true';
      q.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (!expanded) track('vsnl_faq_open', { question: q.textContent.trim().slice(0, 80) });
    });
  });

  /* ---------- Quiz ---------- */
  document.querySelectorAll('[data-vsnl-quiz]').forEach(function (quiz) {
    var stepsEls = quiz.querySelectorAll('.vsnl-quiz__step');
    var idx = 0;
    function show(i) {
      stepsEls.forEach(function (s, n) { s.classList.toggle('is-current', n === i); });
      var prog = quiz.querySelector('.vsnl-quiz__progress');
      if (prog && i < stepsEls.length - 1) {
        prog.textContent = 'Question ' + (i + 1) + ' of ' + (stepsEls.length - 1);
      } else if (prog) {
        prog.textContent = '';
      }
    }
    quiz.querySelectorAll('.vsnl-quiz__opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        track('vsnl_quiz_answer', { step: idx + 1, answer: opt.textContent.trim().slice(0, 60) });
        idx = Math.min(idx + 1, stepsEls.length - 1);
        show(idx);
        if (idx === stepsEls.length - 1) track('vsnl_quiz_complete', {});
      });
    });
    show(0);
  });

  /* ---------- Offer selector (real cart submission) ---------- */
  document.querySelectorAll('[data-vsnl-offer]').forEach(function (root) {
    var opts = root.querySelectorAll('.vsnl-offer__opt');
    var qtyInput = root.querySelector('[data-vsnl-offer-qty]');
    var visual = root.querySelector('.vsnl-offer__visual');
    var visualImg = visual ? visual.querySelector('img') : null;
    var ctaText = root.querySelector('[data-vsnl-offer-cta-text]');

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        opt.setAttribute('aria-pressed', 'true');
        if (qtyInput) qtyInput.value = opt.dataset.quantity || '1';
        if (ctaText && opt.dataset.cta) ctaText.textContent = opt.dataset.cta;
        if (visual && visualImg && opt.dataset.image) {
          visual.classList.add('is-switching');
          setTimeout(function () {
            visualImg.src = opt.dataset.image;
            visual.classList.remove('is-switching');
          }, reducedMotion ? 0 : 250);
        }
        track('vsnl_offer_select', { quantity: opt.dataset.quantity });
      });
    });

    var form = root.querySelector('form[data-vsnl-offer-form]');
    if (form) {
      form.addEventListener('submit', function () {
        track('vsnl_offer_atc', { quantity: qtyInput ? qtyInput.value : '1' });
      });
    }
  });

  /* ---------- Generic CTA tracking ---------- */
  document.querySelectorAll('[data-vsnl-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      track('vsnl_cta_click', { cta: el.dataset.vsnlCta || el.textContent.trim().slice(0, 60) });
    });
  });
})();
